import React from 'react';
import { Link } from 'react-router-dom';
class SearchBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // searchkey: ""
        };
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    render() {
        return (
            <div className="search_area pl-3">
                <form>
                    <div className="row">
                        <div className="col-md-9" style={{ paddingRight: '0px' }}>
                            <input type="text" placeholder='' onChange={this.updateValue.bind(this, "searchkey")} />
                        </div>
                        <Link to={{
                            pathname: `/search-results/${this.state.searchkey}`,
                            state: { id: this.state.searchkey }
                        }}>
                            <button type="submit" style={{ border: '0px solid #ccc', backgroundColor: 'white', width: '40px', height: '30px' }}><i className="fas fa-search"></i></button>
                        </Link>
                    </div>
                </form>
            </div>
        );
    }
}

export { SearchBox };
